<template>
  <v-container fluid class="pa-5">
    <v-layout row wrap>
      <v-flex md11 class="pt-3">
        <bread-crumbs icon="fas fa-code-branch" :items="breadCrumbsItems"/>
      </v-flex>
      <v-flex md1 class="text-xs-right">
        <v-menu v-if="canEdit || canDelete" bottom offset-y left>
          <v-btn slot="activator" color="grey darken-2" flat fab>
            <v-icon class="f2em">fas fa-cog</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile v-if="canEdit" @click="editWorkflow">
              <v-list-tile-title>Editar Flujo</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="canEdit" @click="changeStatusDialog = true">
              <v-list-tile-title>{{ workflow.status === 'Activo' ? 'Desactivar' : 'Activar' }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="canEdit" @click="openLogModal">
              <v-list-tile-title>Log</v-list-tile-title>
            </v-list-tile>
            <v-list-tile v-if="canDelete"  @click="deleteDialog = true">
              <v-list-tile-title>Eliminar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-flex>
    </v-layout>
    <template>
    <stages :workflow="workflow" :stages="stages" :pStages="pStages" :stages-key="stagesKey"
      :is-in-release="isInRelease"
      :is-whatsapp-outbound-active="isWhatsappOutboundActive"
      @p-stage-updated="pStageUpdated"
      @stage-created="stageCreated"
      @p-stage-created="pStageCreated"
      @p-filter-created="pFilterCreated"
      @p-filter-updated="pFilterUpdated"
      @stage-updated="stageUpdated" @stage-deleted="stageDeleted"
      @p-stage-deleted="pStageDeleted"
      @filter-created="filterCreated"
      @filter-updated="filterUpdated" @stage-filter-deleted="filterDeleted"
      @p-filter-deleted="pFilterDeleted" />
    </template>
    <log-modal
      :id="workflow.id"
      :show="showLogModal"
      @close="closeLogModal"
    />
    <workflow-dialog
      :show="workflowDialog"
      :workflow="workflow"
      :is-whatsapp-outbound-active="isWhatsappOutboundActive"
      @created="$router.push(`/flows_v2/${$event.id}`)"
      @updated="workflowUpdated"
      @close="workflowDialog = false"
    />
    <change-status
      :show="changeStatusDialog"
      :workflow="workflow"
      @updated="workflowUpdated"
      @close="changeStatusDialog = false"
    />
    <delete-workflow
      :show="deleteDialog"
      :workflow="workflow"
      @deleted="workflowDeleted"
      @close="deleteDialog = false"
    />
  </v-container>
</template>
<script>
import Vue from 'vue';
import _ from 'lodash';
import Stages from '@/components/V2CollectWorkflows/Detail/WorkflowDetail/Index';
import filtersMixin from '@/mixins/workflowFilters';
import BreadCrumbs from '@/components/global/BreadCrumbs.vue';
import LogModal from './LogModal.vue';
import WorkflowDialog from '@/components/V2CollectWorkflows/WorkflowDialog';
import ChangeStatus from '@/components/CollectWorkflows/ChangeStatus';
import DeleteWorkflow from '@/components/CollectWorkflows/DeleteWorkflow';
import permissionsMixin from '@/mixins/permissions';

const uuidv1 = require('uuid/v1');

export default {
  components: {
    Stages,
    BreadCrumbs,
    LogModal,
    WorkflowDialog,
    ChangeStatus,
    DeleteWorkflow,
  },
  beforeRouteEnter(to, from, next) {
    const workflowId = to.params.workflow;
    Promise.all([
      Vue.axios.get(`workflows/${workflowId}`),
      Vue.axios.get(`v3/workflows/${workflowId}/stages`),
      Vue.axios.get(`workflows/${workflowId}/payment_p_stages`),
      filtersMixin.methods.findFilters(),
      Vue.axios.get('check_release', { params: { name: 'days_off_by_attempts_project' } }),
      Vue.axios.get('check_release', { params: { name: 'colly_senders_api_sms' } }),
      Vue.axios.get('check_release', { params: { name: 'colly_senders_api_email' } }),
      Vue.axios.get('check_release', { params: { name: 'colly_senders_api_whatsapp' } }),
      // Vue.axios.get('check_release', { params: { name: 'whatsapp_outbound_project' } }),
    ]).then((values) => {
      next((vm) => {
        vm.workflow = values[0].data; // eslint-disable-line
        vm.stages = values[1].data; // eslint-disable-line
        vm.pStages = values[2].data; // eslint-disable-line
        vm.sortStages();
        vm.isInRelease = values[4].data.is_active;
        vm.collyRelease.sms = values[5].data.is_active === true; // eslint-disable-line
        vm.collyRelease.email = values[6].data.is_active === true; // eslint-disable-line
        vm.collyRelease.whatsapp = values[7].data.is_active === true; // eslint-disable-line
        // vm.isWhatsappOutboundActive = values[5].data.is_active;
      });
    }).catch(() => { });
  },
  mixins: [
    filtersMixin,
    permissionsMixin,
  ],
  // Release de colly por canal, una vez por página: los diálogos de plantillas lo inyectan.
  provide() {
    return { collyRelease: this.collyRelease };
  },
  data() {
    return {
      workflow: {},
      stages: [],
      pStages: [],
      pStagesKey: uuidv1(),
      stagesKey: uuidv1(),
      isInRelease: false,
      collyRelease: { sms: false, email: false, whatsapp: false },
      isWhatsappOutboundActive: true,
      showLogModal: false,
      workflowDialog: false,
      changeStatusDialog: false,
      deleteDialog: false,
      stageModal: false,
    };
  },
  computed: {
    breadCrumbsItems() {
      const init = [
        {
          title: 'Flujos de cobranza',
          url: '/flows_v3',
        },
      ];

      init.push({
        title: this.workflow.name || 'Gestion',
        url: null,
      },);

      return init;
    },
    canEdit() {
      return this.checkPermissions([
        'edit_workflow_notifications',
        'create_workflow_notifications',
      ]);
    },
    canDelete() {
      return this.checkPermissions([
        'delete_workflow_notifications',
      ]);
    },
  },
  methods: {
    workflowDeleted() {
      this.$router.push('/flows_v2');
      this.deleteDialog = false;
    },
    workflowUpdated(workflow) {
      this.workflow = workflow;
      this.workflowDialog = false;
    },
    editWorkflow() {
      this.workflowDialog = true;
    },
    openLogModal() {
      this.showLogModal = true;
    },
    closeLogModal() {
      this.showLogModal = false;
    },
    sortStages() {
      // eslint-disable-next-line
      this.stages = _.sortBy(this.stages, item => parseInt(item.order, 10) - parseInt(item.global || 0, 10));
      this.stagesKey = uuidv1();
    },
    stageCreated(stage) {
      let stages = this.stages.filter(item => item.global === stage.global);
      if (stage.global) {
        this.stages.splice(stage.order - 1, 0, stage);
      } else {
        const globalStages = this.stages.filter(item => item.global === 1);
        let position = stage.order - 1;
        if (globalStages.length) {
          position = Math.abs(position - globalStages.length - 1);
        }
        this.stages.splice(position, 0, stage);
      }
      stages = this.stages.filter(item => item.global === stage.global);
      for (let i = 1; i <= stages.length; i += 1) {
        const index = this.stages.findIndex(item => item.id === stages[i - 1].id);
        this.stages[index].order = i;
      }
      this.sortStages();
    },
    stageUpdated(selectedStage) {
      const index = this.stages.findIndex(item => item.id === selectedStage.id);
      const currentOrder = this.stages[index].order;
      const newOrder = selectedStage.order;
      if (newOrder < currentOrder) {
        const stageCopy = _.cloneDeep(this.stages);
        for (let i = newOrder; i < currentOrder; i += 1) {
          const index2 = stageCopy.findIndex(item => (
            item.order === i
            && item.global === selectedStage.global
          ));
          this.stages[index2].order = i + 1;
        }
      } else if (newOrder > currentOrder) {
        for (let i = currentOrder + 1; i <= newOrder; i += 1) {
          const index2 = this.stages.findIndex(item => (
            item.order === i
            && item.global === selectedStage.global
          ));
          this.stages[index2].order = i - 1;
        }
      }
      const stage = {
        ...this.stages[index],
        ...selectedStage,
      };
      if (this.stages[index].status === 'Activo' && stage.status === 'Inactivo') {
        for (let i = 0; i < stage.filters.length; i += 1) {
          stage.filters[i].status = 'Inactivo';
        }
      }
      this.$set(this.stages, index, stage);
      this.sortStages();
    },
    stageDeleted(selectedStage) {
      const index = this.stages.findIndex(item => item.id === selectedStage.id);
      this.stages.splice(index, 1);
      this.sortStages();
    },
    filterCreated(event) {
      const { selectedStage, filter } = event;
      const stage = {
        ...selectedStage,
      };
      if (filter.order === stage.filters.length) {
        stage.filters.push(filter);
      } else {
        stage.filters.splice(filter.order - 1, 0, filter);
      }
      for (let i = 1; i <= stage.filters.length; i += 1) {
        stage.filters[i - 1].order = i;
      }
      stage.filters = _.sortBy(stage.filters, item => item.order);
      const index = this.stages.findIndex(item => item.id === stage.id);
      this.$set(this.stages, index, stage);
    },
    filterUpdated(event) {
      const { selectedStage, filter } = event;
      const stage = {
        ...selectedStage,
      };
      const index = stage.filters.findIndex(item => item.id === filter.id);
      const currentOrder = stage.filters[index].order;
      const newOrder = filter.order;
      if (newOrder < currentOrder) {
        for (let i = newOrder; i < currentOrder; i += 1) {
          const index2 = stage.filters.findIndex(item => item.order === i);
          stage.filters[index2].order = i + 1;
        }
      } else if (newOrder > currentOrder) {
        for (let i = currentOrder + 1; i <= newOrder; i += 1) {
          const index2 = stage.filters.findIndex(item => item.order === i);
          stage.filters[index2].order = i - 1;
        }
      }
      stage.filters[index] = filter;
      stage.filters = _.sortBy(stage.filters, item => item.order);
      this.stageUpdated(stage);
    },
    filterDeleted(event) {
      const { selectedStage, selectedFilter } = event;
      const stage = {
        ...selectedStage,
      };
      const index = stage.filters.findIndex(item => item.id === selectedFilter.id);
      stage.filters.splice(index, 1);
      for (let i = 1; i <= stage.filters.length; i += 1) {
        stage.filters[i - 1].order = i;
      }
      stage.filters = _.sortBy(stage.filters, item => item.order);
      this.stageUpdated(stage);
    },
    sortPStages() {
      this.pStages = _.sortBy(this.pStages, item => parseInt(item.days_off, 10));
      this.pStagesKey = uuidv1();
    },
    pStageCreated(pStage) {
      this.pStages.push(pStage);
      this.sortPStages();
    },
    pStageUpdated(selectedPStage) {
      const index = this.pStages.findIndex(item => item.id === selectedPStage.id);
      const pStage = {
        ...this.pStages[index],
        ...selectedPStage,
      };
      if (this.pStages[index].status === 1 && pStage.status === 0) {
        for (let i = 0; i < pStage.filters.length; i += 1) {
          pStage.filters[i].status = 0;
        }
      }
      this.$set(this.pStages, index, pStage);
      this.sortPStages();
    },
    pStageDeleted(selectedPStage) {
      const index = this.pStages.findIndex(item => item.id === selectedPStage.id);
      this.pStages.splice(index, 1);
      this.sortPStages();
    },
    pFilterCreated(event) {
      const {selectedPStage, pFilter} = event;
      const stage = {
        ...selectedPStage,
      };
      stage.filters.push(pFilter);
      const index = this.stages.findIndex(item => item.id === stage.id);
      this.$set(this.stages, index, stage);
    },
    pFilterUpdated(event) {
      const {selectedPStage, pFilter} = event;
      const pStage = {
        ...selectedPStage,
      };
      const index = pStage.filters.findIndex(item => item.id === pFilter.id);
      pStage.filters[index] = pFilter;
      this.pStageUpdated(pStage);
    },
    pFilterDeleted(event) {
      const { pStage, pFilter } = event;

      const index = pStage.filters.findIndex(item => item.id === pFilter.id);
      pStage.filters.splice(index, 1);
      this.pStageUpdated(pStage);
    },
  },
};
</script>

<style scoped>
.settings:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/V2CollectWorkflows/Detail/IndexV2.vue